import type { IBrandConfig } from './types';

const FIRSTAM_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'external',
    url: 'https://homewarranty.firstam.com/privacy',
  },
  termsOfService: {
    kind: 'external',
    url: 'https://homewarranty.firstam.com/legal',
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  vaultProject: 'firstam',
  adaChat: true,
  accountDetails: true,
  secureUpload: false,
  plan: false,
  security: false,
  missingPII: false,
  finishSetup: false,
  defaultBillingCategoryKey: 'identitydefense_partner',
  copyRightEntity: 'Intersections LLC dba Pango',
  hasCustomerServiceSupport: true,
  // ssoRedirectURL: 'https://homewarranty.firstam.com/account/login',
  ssoRedirectURL: null,
  carouselBanners: false,
  dwEmailVerification: {
    adaChat: true,
    signInButton: false,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default FIRSTAM_BRAND_CONFIG;
